import { render, staticRenderFns } from "./FooterInfo.vue?vue&type=template&id=c246a086"
import script from "./FooterInfo.vue?vue&type=script&lang=js"
export * from "./FooterInfo.vue?vue&type=script&lang=js"
import style0 from "./FooterInfo.vue?vue&type=style&index=0&id=c246a086&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports